<script setup lang="ts">
import { mdiChevronRight } from "@mdi/js";
import NavIcon from "../../Nav/NavIcon.vue";
import LiveIndicator from "../LiveIndicator.vue";
import { IEvent } from "~/types/sports/event";

interface Props {
	region: { name: string; sportId: string; regionId: string; sportEvents: IEvent[] };
}

const props = defineProps<Props>();
const hasLive = computed(() => {
	return props.region.sportEvents.some((x) => x.isLive);
});
</script>

<template>
	<NuxtLink
		:to="`/outrights?regionId=${region.regionId}&regionName=${region.name}&sportId=${region.sportId}&fixtureType=outrights`"
		class="relative flex gap-2 p-2 pr-8 text-sm font-bold rounded-md bg-light-50 dark:bg-dark-800 base-text"
	>
		<LiveIndicator class="absolute -top-1 right-6" v-if="hasLive" />
		<DataFreeGuard>
			<NavIcon
				:width="24"
				:height="24"
				:src="`/icons/regions-leagues-flags/${region.regionId.toLowerCase()}-circular.svg`"
				:alt="region.name"
				fallback="/icons/regions-leagues-flags/default-circular.svg"
				class="flex-shrink-0"
			/>
		</DataFreeGuard>

		<span class="overflow-hidden whitespace-nowrap text-ellipsis">{{ region.name }}</span>
		<UiIcon :path="mdiChevronRight" class="absolute w-6 h-6 -translate-y-1/2 fill-dark-800 dark:fill-light-50 top-1/2 right-2" />
	</NuxtLink>
</template>
